export default class Header {
    private header: HTMLElement | null;

    constructor() {
        this.header = document.querySelector(".header");
    }

    public init = async () => window.addEventListener("scroll", () => (window.scrollY > 120 ? this.header?.classList.add("header--active") : this.header?.classList.remove("header--active")));
}
